// extracted by mini-css-extract-plugin
module.exports = {"seleziona_data":"PacchettoDettagliTipo1_seleziona_data__LgFKK","programma_container":"PacchettoDettagliTipo1_programma_container__1x01J"};